/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Merge_Next_Failed_ToastInputs */

const en_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to merge with next event`)
};

const fr_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de fusionner avec l'evenement suivant`)
};

const de_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführung mit dem nächsten Ereignis nicht möglich`)
};

const it_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile unire con l'evento successivo`)
};

const ru_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось объединить с следующим событием.`)
};

const es_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede fusionar con el próximo evento`)
};

const zh_cn2_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法与下一个事件合并`)
};

const ja_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントと統合できません`)
};

const hi_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले इवेंट के साथ मर्ज करने में असमर्थ`)
};

const pt_pt2_shortcut_keys_merge_next_failed_toast = /** @type {(inputs: Shortcut_Keys_Merge_Next_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível mesclar com o próximo evento.`)
};

/**
* | output |
* | --- |
* | "Unable to merge with next event" |
*
* @param {Shortcut_Keys_Merge_Next_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_merge_next_failed_toast = /** @type {((inputs?: Shortcut_Keys_Merge_Next_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Merge_Next_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "de") return de_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "it") return it_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "es") return es_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_merge_next_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_merge_next_failed_toast(inputs)
	return en_shortcut_keys_merge_next_failed_toast(inputs)
});